import { Text } from "@/components/ui/baseUi/text"
import { word } from "@modules/core/utils/i18n"
import { CreditCard } from "lucide-react"

export function CoachAdminBanking() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl bg-surface-foreground p-12 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-surface-background-secondary">
        <CreditCard className="size-6 text-textOnSurface-muted" />
      </div>
      <div className="flex flex-col gap-1">
        <Text fontStyle="TS" className="font-semibold text-textOnSurface-default">
          {word("coach.admin.banking.section_title")}
        </Text>
        <Text fontStyle="BM" className="text-textOnSurface-subtle">
          {word("coach.admin.banking.coming_soon")}
        </Text>
      </div>
    </div>
  )
}
